import { styled, Card, Box, Theme } from '@material-ui/core';

export const ImageItemCont = styled(Card)<Theme, { zoom: boolean }>(({ zoom }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 8,
  margin: 10,
  transition: '300ms',
  position: 'relative',
  cursor: 'pointer',
  '&:hover': {
    transform: zoom ? '' : 'scale(1.1)',
  },
  height: 'fit-content',
  minHeight: 144,
  minWidth: 100,
}));

export const ImageElement = styled('img')<Theme, { zoom: boolean }>(({ zoom }) => ({
  maxHeight: 144,
  minWidth: 100,
  minHeight: 144,
  zoom: zoom ? 2 : 1,
}));

export const MainCont = styled(Box)(() => ({
  borderRadius: 10,
  display: 'flex',
  flexWrap: 'wrap',
  height: '100%',
  alignContent: 'flex-start',
}));
